import {MediaQuery} from '@constants/theme';
import FeaturedCommunityMdSlideWrapper from '@new-components/atoms/FeaturedCommunityMdSlideWrapper';
import MuiBox from '@new-components/atoms/MuiBox';
import MuiSkeleton from '@new-components/atoms/MuiSkeleton';

const FeaturedCarouselSkelton = () => {
  return (
    <>
      <MuiBox sx={{px: 3, [MediaQuery.desktop]: {display: 'none'}}}>
        <MuiSkeleton
          variant='rounded'
          width='100%'
          height={400}
          animation='wave'
        />
      </MuiBox>
      <FeaturedCommunityMdSlideWrapper>
        {Array.from({length: 4}, (_, i) => (
          <MuiSkeleton
            key={i}
            variant='rounded'
            width='25%'
            height={400}
            animation='wave'
          />
        ))}
      </FeaturedCommunityMdSlideWrapper>
    </>
  );
};
export default FeaturedCarouselSkelton;
